import React, { useEffect } from "react";

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

export default function ImageUpload({
  value,
  onChange,
  label,
  testId,
  aspect = "square",
  hint,
}) {
  const inputId = React.useId();
  return (
    <div>
      {label && (
        <label className="text-sm font-medium text-slate-700 mb-1.5 block">
          {label}
        </label>
      )}
      <div className="flex items-center gap-3">
        <div
          className={`${
            aspect === "wide" ? "w-32 h-16" : "w-20 h-20"
          } rounded-md border border-dashed border-slate-300 bg-slate-50 overflow-hidden grid place-items-center`}
        >
          {value ? (
            <img
              src={value}
              alt=""
              className="w-full h-full object-contain"
            />
          ) : (
            <span className="text-xs text-slate-400">no image</span>
          )}
        </div>
        <div className="flex flex-col gap-2">
          <label
            htmlFor={inputId}
            data-testid={testId ? `${testId}-label` : undefined}
            className="cursor-pointer text-sm font-medium text-blue-700 hover:text-blue-900 transition-soft"
          >
            {value ? "Replace" : "Upload"}
          </label>
          {value && (
            <button
              type="button"
              data-testid={testId ? `${testId}-clear` : undefined}
              onClick={() => onChange(null)}
              className="text-xs text-slate-500 hover:text-red-600 transition-soft text-left"
            >
              Remove
            </button>
          )}
          {hint && <span className="text-xs text-slate-400">{hint}</span>}
        </div>
        <input
          id={inputId}
          data-testid={testId}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={async (e) => {
            const f = e.target.files?.[0];
            if (f) onChange(await fileToDataUrl(f));
            e.target.value = "";
          }}
        />
      </div>
    </div>
  );
}
